import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-buyer-personas-clamp',
  templateUrl: './buyer-personas-clamp.component.html',
  standalone: true,
  imports: [NgIf],
  styles: [`
    :host {
      display: block;
    }

    .clamp {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-word;
      white-space: normal;
    }

    .clamp.clamped {
      -webkit-line-clamp: var(--lines, 2);
    }

    .more-link {
      display: inline-block;
      margin-top: 4px;
    }
  `],
})
export class BuyerPersonasClampComponent implements AfterViewInit, OnDestroy {
  @Input() lines = 2;

  @ViewChild('content', { static: true }) contentRef!: ElementRef<HTMLElement>;

  expanded = false;
  showMore = false;

  private resizeObserver?: ResizeObserver;

  ngAfterViewInit(): void {
    const element = this.contentRef?.nativeElement;
    if (!element) {
      return;
    }

    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(element);

    setTimeout(() => this.update());
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  onMoreClick(): void {
    this.expanded = true;
    this.showMore = false;
  }

  private update(): void {
    if (this.expanded) {
      this.showMore = false;
      return;
    }

    const element = this.contentRef?.nativeElement;
    if (!element) {
      this.showMore = false;
      return;
    }

    element.classList.remove('clamped');
    const fullHeight = element.scrollHeight;
    element.classList.add('clamped');
    const clampedHeight = element.clientHeight;

    this.showMore = fullHeight > clampedHeight + 1;
  }
}
